import { render } from "./AnchorTab.vue?vue&type=template&id=499ac1e2&scoped=true&ts=true"
import script from "./AnchorTab.vue?vue&type=script&setup=true&lang=ts"
export * from "./AnchorTab.vue?vue&type=script&setup=true&lang=ts"

import "./AnchorTab.vue?vue&type=style&index=0&id=499ac1e2&lang=scss&scoped=true"

import exportComponent from "/Users/luoke/Desktop/新开发代码_git/h5-jalalive/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-499ac1e2"],['__file',"src/components/player/AnchorTab.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "499ac1e2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('499ac1e2', __exports__)) {
    console.log('reload')
    api.reload('499ac1e2', __exports__)
  }
  
  module.hot.accept("./AnchorTab.vue?vue&type=template&id=499ac1e2&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('499ac1e2', render)
  })

}


export default __exports__